import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import OutletCard from "../../../components/AdminCards/OutletCard";
import { languageHelper } from "../../../config/helperFunctions";
import DeleteModal from "../../../components/Modal/DeleteModal";

function Outlet() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [cardData, setCardData] = useState([]);
  const [selectedId, setselectedId] = useState(null)

  const fetchOutlets = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/get-outlets`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setCardData(res.data);
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  const handleDelete = (id) => {
    setPageLoading(true);
    axios
      .delete(`${apiKey}/api/rms/admin/delete-outlet/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchOutlets();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
    // .finally(() => setPageLoading(false));
  };

  useEffect(() => {
    setPageLoading(true);
    fetchOutlets();
  }, [fetchOutlets]);
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex py-3">
          <div>
            <h1 className="text-d-bg-text text-2xl">{languageHelper("Outlet")}</h1>
          </div>

          <Link
            to="addOutlet"
            className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center ms-auto"
            type="button"
          >
            {languageHelper("Add Outlet")}
          </Link>
          <Link
            to="copyOutletItems"
            className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center ms-2"
            type="button"
          >
            {languageHelper("Copy Items")}
          </Link>
        </div>
        {error && (
          <div
            className="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
            role="alert"
          >
            <svg
              className="flex-shrink-0 inline w-4 h-4 me-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <span className="sr-only">{languageHelper("Info")}</span>
            <div>{error}</div>
          </div>
        )}
        {!error && (
          <div className="grid grid-cols-3 gap-2 mt-5">
            {cardData &&
              cardData.map((data, index) => (
                <OutletCard
                  key={index}
                  data={data}
                  handleDelete={setselectedId}
                />
              ))}
          </div>
        )}
        <span className="w-full bg-d-bg h-1 my-2 mt-8 inline-block"></span>
      </div>
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {selectedId && (
        <DeleteModal
          setIsOpen={setselectedId}
          onDelete={() => handleDelete(selectedId)}
        />
      )}
    </main>
  );
}

export default Outlet;
